import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { GameHistoryUiHistoryListTableModule } from '@fantaz/game-history/ui/history-list-table';
import {
  BestScores,
  CasualTournamentDetails,
  CurrentUser,
  EventSchedule,
  MatchResultsForUser,
} from '@fantaz/shared/data-access/models';
import { EmptyListModule } from '@fantaz/shared/ui/empty-list';
import { TournamentsUiScoreSummaryModule } from '@fantaz/tournaments/ui/score-summary';

@Component({
  selector: 'fz-tab-history',
  standalone: true,
  imports: [
    CommonModule,
    GameHistoryUiHistoryListTableModule,
    TournamentsUiScoreSummaryModule,
    EmptyListModule,
  ],
  templateUrl: './user-play-history.html',
  styleUrls: ['./user-play-history.scss'],
})
export class UserPlayHistory {
  @Input() eventCode?: string;
  @Input() gameHistory: MatchResultsForUser[] | null;
  @Input() totalGameHistory: number | null = 0;
  @Input() loaded: boolean | null;
  @Input() eventRetired?: boolean;
  @Input() isLoggedIn: boolean;
  @Input() eventPrototypeUuid: string | undefined;
  @Input() casualGameStartTime: string | undefined;
  @Input() casualGameEndTime: string | undefined;
  @Input() entryFee: number | undefined;
  @Input() bestScores?: BestScores | undefined;
  @Input() eventScheduleDetails: EventSchedule | null | undefined;
  @Input() user: CurrentUser | null | undefined;
  @Input() prizeImage: string | undefined;
  @Input() isLEP: boolean | undefined;
  @Input() page: {
    pageIndex: number;
    pageSize: number;
  };
  @Input() details?: CasualTournamentDetails | null | undefined;

  @Output() playNow: EventEmitter<void> = new EventEmitter();
  @Output() share: EventEmitter<void> = new EventEmitter();
  @Output() login: EventEmitter<void> = new EventEmitter();
  @Output() gameHistoryPageChange: EventEmitter<{
    pageIndex: number;
    pageSize: number;
  }> = new EventEmitter();
  @Output() viewPlayInstance: EventEmitter<MatchResultsForUser> =
    new EventEmitter<MatchResultsForUser>();
  @Output() tryForFree: EventEmitter<void> = new EventEmitter();

  /**
   * Play control for the tournament
   */
  @Input()
  playControls: TemplateRef<any>;

  onPlay() {
    this.playNow.emit();
  }
  onShare() {
    this.share.emit();
  }
  onTryForFree() {
    this.tryForFree.emit();
  }
  onLogin() {
    this.login.emit();
  }

  onGameHistoryPageChange(pageInfo: { pageIndex: number; pageSize: number }) {
    this.page = pageInfo;
    this.gameHistoryPageChange.emit(pageInfo);
  }

  inTheFuture() {
    if (this.casualGameStartTime) {
      return (
        new Date(this.casualGameStartTime).getTime() > new Date().getTime()
      );
    }
    return false;
  }
}
